import Directory, { Path } from '@src/quince-site-common/src/domains/Directory'
import ProductHierarchy from '@src/quince-site-common/src/domains/ProductHierarchy'
import { removeQueryParams } from '@src/quince-site-common/src/utils/getPathParam'
import { isEmpty } from '@src/utils/functions/utils'

export const getPathsFromProductHierarchy = (hierarchy?: Path[]): Path[] => {
  if (hierarchy?.length) {
    return hierarchy.map(hierarchyItem => {
      return new Path({
        displayName: hierarchyItem.displayName.split('-').join(' '),
        route: hierarchyItem.route,
      })
    })
  } else {
    return []
  }
}

export const getHierarchyFromSlug = (slug: string): Path[] => {
  slug = removeQueryParams(slug)
  let relativePath = ''
  return slug
    .split('/')
    .filter((path: string) => path.trim() !== '')
    .map((slugFragment, index) => {
      relativePath = relativePath + `/${slugFragment}`

      return new Path({
        level: index + 1,
        displayName: slugFragment.split('-').join(' '),
        route: relativePath === '/all' ? '/' : relativePath,
      })
    })
}

const getLevel2HierarchyWithProductName = (
  productHierarchy: ProductHierarchy[],
  productTitle: string,
  route: string,
): Path[] | undefined => {
  const paths = productHierarchy.map(ph => {
    return {
      level: ph.level,
      displayName: ph.displayName,
      route: ph.pageHandle,
    }
  })
  const sortedAndFilteredPaths = paths
    .filter(paths => paths.level <= 2) // Filter out level higher than 2
    .sort((paths1, paths2) => paths1.level - paths2.level) // Sort to ensure levels are in order

  return [
    ...sortedAndFilteredPaths,
    new Path({
      level: sortedAndFilteredPaths.length + 1,
      displayName: productTitle,
      route,
    }), // Add new hierarchy item so that path includes product name
  ]
}

export const getDirectory = (slug: string, productTitle?: string, productHierarchy?: ProductHierarchy[]) => {
  if (
    productTitle &&
    !isEmpty(productHierarchy) &&
    productHierarchy?.every(item => !!item.pageHandle && !!item.displayName)
  ) {
    const slugFragments = slug.split('/')
    const finalPageHandle = slugFragments.length ? `/${slugFragments[slugFragments.length - 1]}` : ''
    const paths = getPathsFromProductHierarchy(
      getLevel2HierarchyWithProductName(productHierarchy, productTitle, finalPageHandle),
    )
    return new Directory({
      paths,
    })
  } else {
    const paths = getPathsFromProductHierarchy(getHierarchyFromSlug(slug))
    return new Directory({
      paths,
    })
  }
}
